<template>
  <main-content class="e-registration-register-success-view">
    <b-card class="e-registration-register-success-view__content">
      <h5>{{ $t("title") }}</h5>
      <p>{{ $t("desc") }}</p>
    </b-card>
  </main-content>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.e-registration-register-success-view {
  &__content {
    position: relative;
    width: 100%;
    top: 15%;
  }
}
</style>

<i18n>
{
  "en": {
    "title": "Registration Completed",
    "desc": "ERegistration Completed. Please login the system."
  },
  "zh_hk": {
    "title": "註冊已完成",
    "desc": "電子註冊已完成。請登入系統."
  },
  "zh_cn": {
     "title": "注册已完成",
    "desc": "电子注册已完成。请登入系统."
  }
}
</i18n>
